import api from '../utils/api';

// Backend: routers/integrations.py — API keys + outbound webhooks for
// third-party integrators (models/integrations.py). Scopes/subscribed
// events reuse the same permission-code catalog as rolesService.js.
const integrationsService = {
  listSupportedEvents: async () => {
    try {
      return await api.get('/api/integrations/events');
    } catch (error) {
      console.error('Error fetching supported webhook events:', error);
      throw error;
    }
  },

  listApiKeys: async () => {
    try {
      return await api.get('/api/integrations/api-keys');
    } catch (error) {
      console.error('Error fetching API keys:', error);
      throw error;
    }
  },
  createApiKey: async (data) => {
    try {
      return await api.post('/api/integrations/api-keys', data);
    } catch (error) {
      console.error('Error creating API key:', error);
      throw error;
    }
  },
  revokeApiKey: async (keyId) => {
    try {
      return await api.delete(`/api/integrations/api-keys/${keyId}`);
    } catch (error) {
      console.error('Error revoking API key:', error);
      throw error;
    }
  },

  listWebhooks: async () => {
    try {
      return await api.get('/api/integrations/webhooks');
    } catch (error) {
      console.error('Error fetching webhook endpoints:', error);
      throw error;
    }
  },
  createWebhook: async (data) => {
    try {
      return await api.post('/api/integrations/webhooks', data);
    } catch (error) {
      console.error('Error creating webhook endpoint:', error);
      throw error;
    }
  },
  updateWebhook: async (endpointId, data) => {
    try {
      return await api.put(`/api/integrations/webhooks/${endpointId}`, data);
    } catch (error) {
      console.error('Error updating webhook endpoint:', error);
      throw error;
    }
  },
  deleteWebhook: async (endpointId) => {
    try {
      return await api.delete(`/api/integrations/webhooks/${endpointId}`);
    } catch (error) {
      console.error('Error deleting webhook endpoint:', error);
      throw error;
    }
  },
  listWebhookDeliveries: async (endpointId) => {
    try {
      return await api.get(`/api/integrations/webhooks/${endpointId}/deliveries`);
    } catch (error) {
      console.error('Error fetching webhook deliveries:', error);
      throw error;
    }
  },

  // Biometric devices (routers/integrations.py, models/integrations.py:BiometricDevice) —
  // registered devices allowed to push attendance punches to
  // /api/public/v1/biometric/student-punch and /staff-punch.
  listBiometricDevices: async () => {
    try {
      return await api.get('/api/integrations/biometric-devices');
    } catch (error) {
      console.error('Error fetching biometric devices:', error);
      throw error;
    }
  },
  createBiometricDevice: async (data) => {
    try {
      return await api.post('/api/integrations/biometric-devices', data);
    } catch (error) {
      console.error('Error creating biometric device:', error);
      throw error;
    }
  },
  updateBiometricDevice: async (deviceId, data) => {
    try {
      return await api.put(`/api/integrations/biometric-devices/${deviceId}`, data);
    } catch (error) {
      console.error('Error updating biometric device:', error);
      throw error;
    }
  },
  deleteBiometricDevice: async (deviceId) => {
    try {
      return await api.delete(`/api/integrations/biometric-devices/${deviceId}`);
    } catch (error) {
      console.error('Error deleting biometric device:', error);
      throw error;
    }
  },
};

export default integrationsService;
